"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Monogram = void 0;
const tslib_1 = require("tslib");
const styled_1 = tslib_1.__importDefault(require("@emotion/styled"));
const react_core_1 = require("@neo-one/react-core");
const react_1 = tslib_1.__importDefault(require("react"));
const monogram_svg_1 = tslib_1.__importDefault(require("./static/img/monogram.svg"));
const StyledImage = styled_1.default(react_core_1.Image) `
  height: 56px;
`;
exports.Monogram = (props) => (react_1.default.createElement(StyledImage, Object.assign({ src: monogram_svg_1.default, alt: "NEO\u2022ONE" }, props)));

//# sourceMappingURL=Monogram.js.map
